import { PluginBuilder, TeiaViewer } from '@stereograph/teiaviewer';
import { setupPluginsTranslation } from '@translation';
import { ShowDocumentViewerWidget } from './ToolbarItems';
import { DocumentViewerWidget } from './widgets/DocumentViewerWidget';

declare global {
  interface ViewerPluginRegistry {
    documentViewer: DocumentViewerPlugin;
  }
}

const PluginBaseClass = PluginBuilder.NewPlugin('DocumentViewerPlugin');

export class DocumentViewerPlugin extends PluginBaseClass<TeiaViewer> {
  static override readonly ToolbarItems = {
    ShowDocumentViewerWidget,
  };

  override onRegister(): void {
    setupPluginsTranslation();
    this._setupWidgets();
  }

  private _setupWidgets() {
    this.viewer.widgetFactory.registerWidget(
      'DocumentViewer', ({ documentViewerProps, title, ...options }) => {
        return new DocumentViewerWidget(this.viewer, documentViewerProps, title, {
          minHeight: 300,
          minWidth: 300,
          ...options,
        });
      });
  }
}
